import type { FolderCommitResponse } from '@/lib/api';

/** How many of a folder load's statements restated a fact the store already
 *  held: the statements written less what the graphs grew by, less the values
 *  that replaced a held one (written, but the graph did not grow by them).
 *  Only when every number is known and the load added rather than replaced;
 *  otherwise null. */
export function restatedCount(
  report: FolderCommitResponse,
): { read: number; added: number; restated: number } | null {
  const loaded = report.items.filter((i) => i.ok);
  if (loaded.length === 0 || loaded.some((i) => i.statements == null)) return null;
  if (report.graphs.some((g) => g.before == null || g.after == null || g.after < g.before)) return null;
  const read = loaded.reduce((n, i) => n + (i.statements ?? 0), 0);
  const added = report.graphs.reduce((n, g) => n + ((g.after ?? 0) - (g.before ?? 0)), 0);
  const restated = read - added - valueUpdates(report).updated;
  return restated > 0 ? { read, added, restated } : null;
}

/** The folder load's values updated and older values not applied, summed
 *  over its items. */
export function valueUpdates(report: FolderCommitResponse): { updated: number; notAppliedOlder: number } {
  return report.items.reduce(
    (n, i) => ({
      updated: n.updated + (i.updated ?? 0),
      notAppliedOlder: n.notAppliedOlder + (i.not_applied_older ?? 0),
    }),
    { updated: 0, notAppliedOlder: 0 },
  );
}
